<app-navbar></app-navbar>
<div class="container-fluid" style="margin-top: 6rem;width: 90%;">
<br>
<img src="../../../assets/images/web/exportaciones/expo1.jpeg" width="100%" alt="">
<br>
<img src="../../../assets/images/web/exportaciones/expo3.png" width="100%" alt="">
</div>
<br>
<app-footer></app-footer>
